export const campaignTypes = {
    automation: 'lime',
    campaign: 'cyan',
};